module.exports = __webpack_public_path__ + "media/images/homes/Group94-97b897ee10687697e3708a71f6b78fd3.png";